

import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#041A12] text-text-light">
      <div className="max-w-[1400px] mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Columna 1 - Marca */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/4b33f3b8-427f-4570-abed-0966eedfc6e3.png"
                alt="PLADUREX"
                className="h-10 w-auto"
              />
              <span className="text-xl font-bold text-primary-yellow">PLADUREX</span>
            </Link>
            <p className="text-sm text-gray-300 leading-relaxed mb-4">
              Instalación profesional de pladur en Terrassa y alrededores. Acabados limpios, obra rápida y soluciones a medida.
            </p>
            <Link
              to="/empresa"
              className="text-sm text-primary-yellow hover:text-accent-lime transition-colors inline-flex items-center gap-1"
            >
              Conoce nuestra empresa
              <i className="ri-arrow-right-s-line"></i>
            </Link>
          </div>

          {/* Columna 2 - Navegación */}
          <div>
            <h4 className="text-primary-yellow text-xs uppercase font-semibold mb-4 tracking-wider">
              Navegación
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-300 hover:text-primary-yellow transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/empresa" className="text-sm text-gray-300 hover:text-primary-yellow transition-colors">
                  Sobre PLADUREX
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-sm text-gray-300 hover:text-primary-yellow transition-colors">
                  Servicios de Pladur
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-gray-300 hover:text-primary-yellow transition-colors">
                  Preguntas Frecuentes
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-sm text-gray-300 hover:text-primary-yellow transition-colors">
                  Contacto y Presupuesto
                </Link>
              </li>
            </ul>
          </div>

          {/* Columna 3 - Servicios */}
          <div>
            <h4 className="text-primary-yellow text-xs uppercase font-semibold mb-4 tracking-wider">
              Servicios
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/servicios" className="text-sm text-gray-300 hover:text-primary-yellow transition-colors">
                  Tabiques de Pladur en Terrassa
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-sm text-gray-300 hover:text-primary-yellow transition-colors">
                  Trasdosados con Aislamiento
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-sm text-gray-300 hover:text-primary-yellow transition-colors">
                  Falsos Techos de Pladur
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-sm text-gray-300 hover:text-primary-yellow transition-colors">
                  Aislamiento Acústico Profesional
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-sm text-gray-300 hover:text-primary-yellow transition-colors">
                  Aislamiento Térmico
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-sm text-gray-300 hover:text-primary-yellow transition-colors">
                  Pladur Antihumedad para Baños
                </Link>
              </li>
            </ul>
          </div>

          {/* Columna 4 - Contacto */}
          <div>
            <h4 className="text-primary-yellow text-xs uppercase font-semibold mb-4 tracking-wider">
              Contacto
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="tel:+34629501941"
                  className="text-sm text-gray-300 hover:text-primary-yellow transition-colors flex items-center gap-2"
                >
                  <i className="ri-phone-line"></i>
                  +34 629 501 941
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/34629501941"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-300 hover:text-primary-yellow transition-colors flex items-center gap-2"
                >
                  <i className="ri-whatsapp-line"></i>
                  WhatsApp
                </a>
              </li>
              <li className="text-sm text-gray-300 flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>Terrassa, Vallès, Barcelona</span>
              </li>
            </ul>
            <Link
              to="/contacto"
              className="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-primary-yellow text-deep-green text-sm font-semibold rounded-lg hover:shadow-[0_0_15px_rgba(255,212,0,0.4)] transition-all duration-300"
            >
              <i className="ri-mail-send-line"></i>
              Pedir Presupuesto Gratis
            </Link>
          </div>
        </div>
      </div>

      {/* Banda inferior */}
      <div className="bg-black py-5">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-[13px] text-gray-400 text-center md:text-left">
              © 2025 PLADUREX — Instalación de Pladur en Terrassa | Todos los derechos reservados
            </p>
            <div className="flex items-center gap-4 text-[13px]">
              <Link to="/politica-cookies" className="text-gray-400 hover:text-primary-yellow transition-colors whitespace-nowrap">
                Política de Cookies
              </Link>
              <Link to="/aviso-legal" className="text-gray-400 hover:text-primary-yellow transition-colors whitespace-nowrap">
                Aviso Legal
              </Link>
              <Link to="/politica-privacidad" className="text-gray-400 hover:text-primary-yellow transition-colors whitespace-nowrap">
                Política de Privacidad
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
